export default __webpack_public_path__ + "static/rrr-website-1400-6373d6a8ff9c4205d0bc9e1eaf539b82.jpg";